import styled from "@emotion/styled";

export const SignOutButtonContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;
